import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { PickingProductsResponse } from 'src/models/PickingProducts';

@Injectable({
  providedIn: 'root'
})
export class V3PickingDataSourceService {
  baseUrl = `${environment.v3BaseUrl}/api/v3/admin-desktop`;

  constructor(private http: HttpClient) { }

  getPickingProducts(): Promise<PickingProductsResponse> {
    return this.http.get<PickingProductsResponse>(`${this.baseUrl}/picking/products`).toPromise();
  }
}
